module.exports = __webpack_public_path__ + "static/img/cloudnew.a26018e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/nsfcdemo/cloudnew.jpeg
// module id = JDru
// module chunks = 2